// removed by extract-text-webpack-plugin
module.exports = {"notification":"_3qM9FpC3vSVE6wfOOjYCZ0","is-active":"_2DggSgr6LS-rpHiMoWiAkt","success":"_3ZMGt095FbE8_vL-Bp3rF9","error":"IHJGgk-I8sFPt6I62cHQl","warning":"_3WjC8qAuWEuNMpmwr35OA_","notification__close":"_1aiRq757DEtuA_-r7vi71W"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Notification/styles.scss
// module id = 1172
// module chunks = 1